export default "__VITE_ASSET__DY02qWkl__"